export default __webpack_public_path__ + "static/media/motor-pelak.a20012a0.jpg";